// extracted by mini-css-extract-plugin
module.exports = {"testing":"style_testing__1caHX"};